/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as currencyService from '../services/currencyService'
class CurrencyMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currencyList:[]
    };
  }  
  componentDidMount(){
      currencyService.getCurrency().then((res)=>{
        if(!!res){
          this.setState({currencyList:res})
        }
      })
  }
  render() {
    return (
      <body className="bethubs">
        <Header history = {this.props.history} />
        <div className="wrapper">
          <div className="w3-sidebar w3-bar-block w3-border-right" style={{ "display": "none" }} id="mySidebar">
            <button onclick="w3_close()" className="w3-bar-item w3-large bg-hover">Close &times;</button>
            <ul>
              <li><a href="list-of-clients.html">List of Clients</a></li>
              <li><a href="#">Market Analysis</a></li>
              <li><a href="import-event.html">Import Event</a></li>
              <li>
                <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Live Markets </a>
                <ul className="list-unstyled collapse" id="homeSubmenu" >
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
              <li>
                <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Reports</a>
                <ul className="list-unstyled collapse" id="home1Submenu" >
                  <li><a href="#">Test 1</a></li>
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="container-fluid container-padding-0">
            <div className="row">
               <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="main-box">
                     <h5 className="text-blue">Currency Master</h5>
                     <div className="table-responsive">
                            <table id="example" className="table table-striped table-bordered font-14 table-sm">
                                <thead>
                                    <tr>
                                        <th>Sr.No.</th>
                                        <th>Currency Name</th>
                                        <th>Currency Name</th>
                                    </tr>
                                </thead>
                                <tbody id="myBets">
                                    {this.state.currencyList.map((cur,i)=>{
                                      return (<tr>
                                        <td>{i+1}</td>
                                        <td><input type="text" className="form-control" value={cur.currencyName} placeholder="INR" disabled="disabled" /></td>
                                        <td><input type="text" className="form-control" value={cur.currencyValue} placeholder="1" disabled="disabled" /></td>
                                    </tr>)
                                    })}
                                </tbody>
                            </table>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
        </div>
        <Footer />
      </body>
    )
  }
}
function mapStateToProps(state) {
  return {
  };
}
function mapDispatchToProps(dispatch) {
  return {
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CurrencyMaster);